import React, { useEffect, useState, FC } from 'react';
import { css } from 'styled-components';

import { useTranslation } from '@crehana/i18n';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';

interface StickyButtomDownloadProps {
  downloadResource(): void;
}

const StickyButtomDownload: FC<StickyButtomDownloadProps> = ({
  downloadResource,
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const heroSection = document.getElementById('top-section');

    const observer = new IntersectionObserver(
      ([e]) => {
        setIsSticky(!e?.isIntersecting);
      },
      { threshold: [0, 1] },
    );

    if (heroSection) {
      observer.observe(heroSection);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className={`flex items-center justify-center md:block sticky md:fixed right-0 md:top-0 py-12 md:p-0 md:mt-32 md:mr-24${
        isSticky ? ' show' : ''
      }`}
      css={css`
        opacity: 0;
        transition: all 200ms ease-in-out;
        visibility: hidden;
        z-index: 9000;
        ${props => props.theme.breakpoints.down('md')} {
          background-color: rgba(15, 17, 36, 0.95);
          backdrop-filter: blur(20px);
          left: 0;
          bottom: 0;
        }
        &.show {
          opacity: 1;
          visibility: visible;
        }
      `}
    >
      <PrimaryButton label={t('FREE_DOWNLOAD')} onClick={downloadResource} />
    </div>
  );
};

export default StickyButtomDownload;
